import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  // {
  //   path: '*',
  //   redirect: '/'
  // },
  {
    name: '/',
    component: () => import('./view/index'),
    meta: {
      // title: '会员中心'
    }
  },
  {
    name: 'memory',
    component: () => import('./view/memory'),
  },
  {
    name: 'illustration',
    component: () => import('./view/illustration'),
  },
  {
    name: 'reward',
    component: () => import('./view/reward'),
  },
  {
    name: 'rule',
    component: () => import('./view/rule'),
  },
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ routes });

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export {
  router
};
